import { lazy } from 'react';
import { SinglePath, pathFactory } from '@hwm/ui-lib';
import { SpillGuardFeatureFlags } from '@infrastructure/permissions/permissions';

const DashboardComponent = lazy(() => import(`@features/dashboard`));
const ChamberHistoryComponent = lazy(() => import(`@features/chamberHistory`));
const NewSpillsComponent = lazy(() => import(`@features/newSpills`));
const CookieSettings = lazy(() => import('@features/CookieSettings/CookieSettings'));

const baseUrlWithSidebarPaths = (baseUrl: string, featureFlag?: SpillGuardFeatureFlags, permissions?: string[]) => {
  const paths = {
    base: { path: `/${baseUrl}` },
    withSidebarSite: {
      pathWithParam: `/${baseUrl}/site/:id`,
      getLink: ({ id }: { id: string | number }) => `/${baseUrl}/site/${id}`,
    },
    withSidebarSiteGraph: {
      pathWithParam: `/${baseUrl}/site/:id/graph`,
      getLink: ({ id }: { id: string | number }) => `/${baseUrl}/site/${id}/graph`,
    },
    withSidebarSiteAlarms: {
      pathWithParam: `/${baseUrl}/site/:id/alarms`,
      getLink: ({ id }: { id: string | number }) => `/${baseUrl}/site/${id}/alarms`,
    },
  };

  Object.keys(paths).forEach((key) => {
    const path = (paths as { [key: string]: SinglePath })[key];

    if (typeof path === 'string') {
      return;
    }

    path.permissions = permissions ?? null;
    path.featureFlag = featureFlag ?? null;
  });

  return paths;
};

export const AppPaths = {
  spillGuard: pathFactory(
    {
      ...baseUrlWithSidebarPaths('sitemap'),
    },
    DashboardComponent,
    true
  ),
  chamberHistory: pathFactory(
    {
      ...baseUrlWithSidebarPaths('chamberHistory'),
    },
    ChamberHistoryComponent,
    true
  ),
  newSpills: pathFactory(
    {
      ...baseUrlWithSidebarPaths('newspills', SpillGuardFeatureFlags.NewSpills),
    },
    NewSpillsComponent,
    true
  ),
  cookieSettings: pathFactory(
    {
      base: { path: '/cookie-settings' },
    },
    CookieSettings,
    true
  ),
} as const;

export type AppPathsType = typeof AppPaths;
